if($('#component-application-voting').length){
    var app = new Vue({
        el: '#component-application-voting',
        data: {
            data: {},
            currentUserVote: null,
            currentUserId: currentUserId,
            networkSlug: networkSlug,
            networkGroupSlug: networkGroupSlug,
            applicationId: applicationId,
            applicationType: applicationType,
            loading: true
        },
        methods:{
            get(){
                axios.get('/api/v1/network/'+this.networkSlug+'/'+this.applicationType+'/'+this.applicationId+'/vote' ).then((response) =>  {
                    this.data = response.data;

                    this.setCurrentUser();
                    this.loading = false;
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            store(like){
                axios.post('/api/v1/network/'+this.networkSlug+'/'+this.applicationType+'/'+this.applicationId+'/vote', {'like':like}).then((response) =>  {
                    this.data = response.data;
                    this.setCurrentUser();
                    this.$toasted.success('Your vote has been added');
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            update(id, like){
                axios.patch('/api/v1/network/'+this.networkSlug+'/'+this.applicationType+'/'+this.applicationId+'/vote/'+id, {'like':like}).then((response) =>  {
                    this.data = response.data;
                    this.setCurrentUser();
                    this.$toasted.success('Your vote has been updated');
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            updateOrStore(like){
                if(this.currentUserVote){
                    this.update(this.currentUserVote.id, like);
                }else{
                    this.store(like);
                }
            },
            errorHandler(error){
                if(error.response && typeof error.response.data === 'string'){
                    this.$toasted.error(error.response.data);
                }else{
                    this.$toasted.error(error.response.data.message);
                }
            },
            setCurrentUser(){
                var result = this.data.find(vote => {
                    return vote.user_id == this.currentUserId;
                });

                this.currentUserVote = result;
            },
            countForOrAgainst(like){
                var result = this.data.filter(vote => {
                    return vote.like == like;
                });

                return result.length;
            }
        },
        mounted () {
            this.get();
        }
    });
}